import React from 'react';
import { MIcon } from '../../Components/Icon';
import { StatefulTooltip } from '../../Components/Tooltip';
import { StyleObject, useStyletron } from '../../Themes';
import { focusRing } from '../../Themes/base/focusRing';

export const CloseIcon = ({ style = {}, role = 'button', tabIndex = 0, size, ...args }: any) => {
	const [css]: any = useStyletron();

	return (
		<MIcon
			{...args}
			icon="close"
			size={size === 'large' ? '24px' : '18px'}
			color="var(--epods--color-text-primary)"
			className={css({ ...style })}
			title={null}
		/>
	);
};

interface CloseIconComponentProps {
	onClick?: any;
	onHover?: any;
	onKeyPress?: any;
	style?: StyleObject;
	role?: 'button';
	placement?: 'bottom';
	tabIndex?: 0;
	$clearable?: any;
	$creatable?: any;
	$isLoading?: any;
	$isOpen?: any;
	$isPseudoFocused?: any;
	$multi?: any;
	$searchable?: any;
	$isEmpty?: any;
	$type?: any;
	clearable?: any;
	creatable?: any;
	isLoading?: any;
	isOpen?: any;
	isPseudoFocused?: any;
	multi?: any;
	searchable?: any;
	isEmpty?: any;
	type?: any;
	size?: string;
	tooltipContent?: 'Close' | 'Clear' | undefined;
}

export const CloseIconComponent: React.FC<CloseIconComponentProps> = (props: CloseIconComponentProps) => {
	const {
		onClick,
		onHover,
		onKeyPress,
		style = {},
		role,
		placement,
		tabIndex,
		$clearable,
		$creatable,
		$isLoading,
		$isOpen,
		$isPseudoFocused,
		$multi,
		$searchable,
		$isEmpty,
		$type,
		clearable,
		creatable,
		isLoading,
		isOpen,
		isPseudoFocused,
		multi,
		searchable,
		isEmpty,
		type,
		tooltipContent = 'Close',
		...args
	} = props;
	const onKeyPressLocal = (e: any) => {
		const enterOrSpace =
			e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar' || e.which === 13 || e.which === 32;
		if (enterOrSpace) {
			e.preventDefault();
			onClick(e);
		}
		if (onKeyPress) {
			onKeyPress(e);
		}
	};
	// TODO: move the Hook React.useRef to a real functional component
	const mountNode = React.useRef<HTMLDivElement | null>(null);
	const [css] = useStyletron();

	return (
		<div ref={mountNode} className={css(style)}>
			<StatefulTooltip
				content={tooltipContent}
				// @ts-ignore
				mountNode={mountNode.current}
				placement={placement}
				ignoreBoundary
			>
				<span
					role="button"
					tabIndex={0}
					onClick={onClick}
					onKeyPress={onKeyPressLocal}
					aria-label={tooltipContent}
					className={css({
						display: 'flex',
						cursor: 'pointer',
						borderRadius: '2px',
						':focus': focusRing,
						width: 'fit-content',
					})}
				>
					<CloseIcon {...args} />
				</span>
			</StatefulTooltip>
		</div>
	);
};

export const borderWidth = (value: string) => {
	return {
		borderTopWidth: value,
		borderBottomWidth: value,
		borderRightWidth: value,
		borderLeftWidth: value,
	};
};

export const borderColor = (value: string) => {
	return {
		borderTopColor: value,
		borderBottomColor: value,
		borderRightColor: value,
		borderLeftColor: value,
	};
};

export const borderStyle = (value: string) => {
	return {
		borderTopStyle: value,
		borderBottomStyle: value,
		borderRightStyle: value,
		borderLeftStyle: value,
	};
};

export const borderRadius = (value: string) => {
	return {
		borderTopLeftRadius: value,
		borderTopRightRadius: value,
		borderBottomRightRadius: value,
		borderBottomLeftRadius: value,
	};
};

export const marginSize = (top: string, right: string, bottom: string, left: string) => {
	return {
		marginTop: top,
		marginBottom: bottom,
		marginRight: right,
		marginLeft: left,
	};
};

export const paddingSize = (top: string, right: string, bottom: string, left: string) => {
	return {
		paddingTop: top,
		paddingBottom: bottom,
		paddingRight: right,
		paddingLeft: left,
	};
};
